import QueryKeys from '@src/constants/queryKeys';
import useApiQuery from '@hooks/useApiQuery';

export default ({
  deviceType,
  options,
  queryKeys,
}: {
  deviceType: string;
  options: { enabled: boolean };
  queryKeys: string[];
}) =>
  useApiQuery<{
    devices: { name: string; deviceId: string; engineeringId: string }[];
  }>({
    queryKey: [...queryKeys, QueryKeys.parentControllers],
    apiPath: `/devices/parent-controllers?deviceType=${deviceType}`,
    method: 'GET',
    useV2API: true,
    enabled: options.enabled,
  });
